import React from "react";

import styled from 'styled-components';

const StyledDisabledDiv = styled.div`
  && {
    cursor: not-allowed;
    background-color: #e5e5e5;
    opacity: 0.5;
    pointer-events: none;
  }
`;

type Props = {
  children: React.ReactElement | React.ReactElement[];
  disabled:boolean;
  className?:string;
}

const Disable = ({disabled, children, className}:Props)=>{
  if(!disabled) return <div className={className}>{children}</div>;

  return <StyledDisabledDiv disabled className={className}>{children}</StyledDisabledDiv>
}

export default Disable;